import * as React from "react";

import { first, last } from "../lib/utils";
import BaseCalendarView, {
  type BaseCalendarViewProps,
  type CalendarWithHeaderViewProps,
  type SingleSelectionCalendarViewProps,
} from "./BaseCalendarView";
import Calendar from "./Calendar";
import Body from "./CalendarBody/Body";
import Header from "./CalendarHeader/Header";

const YEAR_CALENDAR_ROW_WIDTH = 3;

type YearViewProps = BaseCalendarViewProps &
  SingleSelectionCalendarViewProps &
  CalendarWithHeaderViewProps;

class YearView extends BaseCalendarView<YearViewProps, any> {
  public render() {
    const {
      values,
      onNextPageBtnClick,
      onPrevPageBtnClick,
      onValueClick,
      hasNextPage,
      hasPrevPage,
      onHeaderClick,
      disabledItemIndexes,
      activeItemIndex,
      hoveredItemIndex,
      onCellHover,
      onMount,
      inline,
      localization,
      ...rest
    } = this.props;
    const headerTitle = `${first(values)} - ${last(values)}`;

    return (
      <Calendar
        ref={(e) => {
          this.calendarNode = e as any;
        }}
        outlineOnFocus={inline}
        {...(rest as any)}
      >
        <Header
          className="suicr-year-view-header"
          title={headerTitle}
          onNextPageBtnClick={onNextPageBtnClick}
          onPrevPageBtnClick={onPrevPageBtnClick}
          hasNextPage={hasNextPage}
          hasPrevPage={hasPrevPage}
          onHeaderClick={onHeaderClick}
          width={YEAR_CALENDAR_ROW_WIDTH}
          displayWeeks={false}
          localization={localization}
        />
        <Body
          width={YEAR_CALENDAR_ROW_WIDTH}
          data={values}
          hovered={hoveredItemIndex}
          onCellHover={onCellHover}
          onCellClick={onValueClick}
          active={activeItemIndex}
          disabled={disabledItemIndexes}
        />
      </Calendar>
    );
  }
}

export default YearView;
